export const ua = {
    REQUIRED_ACTION_KeepCapturing: 'Продовжуйте захоплювати.',
    REQUIRED_ACTION_PauseCapturing: 'Призупинення захоплення',
    REQUIRED_ACTION_Close: 'Закрити',
    REQUIRED_ACTION_Error: 'Помилка',
    REQUIRED_ACTION_AGREE: 'Згоден',
    REQUIRED_ACTION_DISAGREE: 'Не згоден',
    LIVENESS_ACTION_Smile: 'Усмішка',
    LIVENESS_ACTION_Frown: 'Нахмуритися',
    'LIVENESS_ACTION_Tilt Left': 'Подивись ліворуч.',
    'LIVENESS_ACTION_Tilt Right': 'Дивись праворуч.',
    'LIVENESS_ACTION_Tilt Up': 'Поглянь вгору',
    'LIVENESS_ACTION_Tilt Down': 'Дивись вниз.',
    'LIVENESS_ACTION_Look Straight': 'Дивись прямо вперед.',
    'LIVENESS_ACTION_No Action': 'Ніяких дій',
    LIVENESS_ACTION_PROCESSING_LIVENESS: 'Обробка Liveness',
    'LIVENESS_RESULT_Thank you!.Failed': 'Не вдалося',
    'LIVENESS_RESULT_Thank you!.Passed': 'Пройшов.',
    'LIVENESS_RESULT_Thank you!.ActionTimedOut':
        'Дія завершилася через тайм-аут.',
    'LIVENESS_RESULT_Thank you!.Interrupted': 'Перерваний',
    'LIVENESS_RESULT_Thank you!.Undefined': 'Невизначений',
    LIVENESS_ACTION_LOOK_STRAIGHT_TITLE: 'Дивіться прямо перед собою.',
    LIVENESS_ACTION_LOOK_STRAIGHT_TEXT: 'Тримайте погляд на екрані весь час',
    LIVENESS_ACTION_LOOK_LEFT_TITLE: 'Поверніть голову трохи вліво',
    LIVENESS_ACTION_LOOK_LEFT_TEXT: 'Тримайте погляд на екрані весь час',
    LIVENESS_ACTION_LOOK_RIGHT_TITLE: 'Злегка поверніть голову праворуч',
    LIVENESS_ACTION_LOOK_RIGHT_TEXT: 'Тримайте погляд на екрані весь час',
    LIVENESS_ACTION_LOOK_UP_TITLE: 'Поверніть голову трохи вгору',
    LIVENESS_ACTION_LOOK_UP_TEXT: 'Тримайте погляд на екрані весь час',
    LIVENESS_ACTION_LOOK_DOWN_TITLE: 'Поверніть голову трохи вниз',
    LIVENESS_ACTION_LOOK_DOWN_TEXT: 'Тримайте погляд на екрані весь час',
    LIVENESS_ACTION_SMILE_TITLE: 'Посміхніться',
    LIVENESS_ACTION_SMILE_TEXT: 'Тримайте очі на екрані весь час',
    LIVENESS_ACTION_FROWN_TITLE: 'Насупитися',
    LIVENESS_ACTION_FROWN_TEXT: 'Постійно тримайте очі на екрані',
    PASSIVE_LIVENESS_ERROR_FACE_TOO_CLOSE_TITLE: 'Ой... Ви занадто близько.',
    PASSIVE_LIVENESS_ERROR_FACE_CLOSE_TO_BORDER_TITLE:
        'Ой... Ви занадто близько.',
    PASSIVE_LIVENESS_ERROR_FACE_CROPPED_TITLE:
        'Щось пішло не так. Спробуйте ще раз.',
    PASSIVE_LIVENESS_ERROR_FACE_CROPPED: 'Щось пішло не так. Спробуйте ще раз.',
    PASSIVE_LIVENESS_ERROR_FACE_NOT_FOUND_TITLE:
        'Ми не можемо виявити обличчя на зображенні. Спробуйте ще раз.',
    PASSIVE_LIVENESS_ERROR_FACE_TOO_SMALL_TITLE: 'Ой... Ви надто далеко.',
    PASSIVE_LIVENESS_ERROR_FACE_ANGLE_TOO_LARGE_TITLE:
        'Ой... Щось пішло не так.',
    ASSIVE_LIVENESS_ERROR_FACE_ANGLE_TOO_LARGE:
        'Щось пішло не так. Спробуйте ще раз.',
    PASSIVE_LIVENESS_ERROR_TOO_MANY_FACES:
        'Ми не можемо визначити обличчя на зображенні. Спробуйте ще раз.',
    PASSIVE_LIVENESS_ERROR_FACE_IS_OCCLUDED_TITLE:
        'Ой... Ми не можемо визначити обличчя.',
    PASSIVE_LIVENESS_ERROR_UNKNOWN_TITLE: 'Ой... Щось пішло не так.',
    PASSIVE_LIVENESS_ERROR_UNKNOWN: 'Щось пішло не так. Спробуйте ще раз.',
    PASSIVE_LIVENESS_ERROR_INTERNAL_TITLE: 'Ой... Щось пішло не так.',
    PASSIVE_LIVENESS_ERROR_INTERNAL: 'Щось пішло не так. Спробуйте ще раз.',
    PASSIVE_LIVENESS_ERROR_LOW_THRESHOLD_TITLE: 'Ой... Щось пішло не так.',
    PASSIVE_LIVENESS_ERROR_LOW_THRESHOLD:
        'Щось пішло не так. Спробуйте ще раз.',
    PASSIVE_LIVENESS_ERROR_None_TITLE: 'Ой... Щось пішло не так.',
    PASSIVE_LIVENESS_ERROR_None: 'Щось пішло не так. Спробуйте ще раз.',
    PASSIVE_LIVENESS_ERROR_FailedExpressions_TITLE: 'Ой... Щось пішло не так.',
    PASSIVE_LIVENESS_ERROR_FailedExpressions:
        'Щось пішло не так. Спробуйте ще раз.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_IMAGE_TITLE:
        'Ой... Щось пішло не так.',
    PASSIVE_LIVENESS_ERROR_IMAGE_ERROR_TITLE: 'Ой... Щось пішло не так.',
    PASSIVE_LIVENESS_ERROR_IMAGE_ERROR: 'Щось пішло не так. Спробуйте ще раз.',
    PASSIVE_LIVENESS_ERROR_INTERNAL_ERROR_TITLE: 'Ой... Щось пішло не так.',
    PASSIVE_LIVENESS_ERROR_INTERNAL_ERROR:
        'Щось пішло не так. Спробуйте ще раз.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_WRITE_IMAGE_TITLE:
        'Ой... Щось пішло не так.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_WRITE_IMAGE:
        'Щось пішло не так. Спробуйте ще раз.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_MODEL_TITLE:
        'Ой... Щось пішло не так.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_MODEL:
        'Щось пішло не так. Спробуйте ще раз.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_ALLOCATE_TITLE: 'Ой... Щось пішло не так.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_ALLOCATE:
        'Щось пішло не так. Спробуйте ще раз.',
    PASSIVE_LIVENESS_ERROR_INVALID_CONFIG_TITLE: 'Ой... Щось пішло не так.',
    PASSIVE_LIVENESS_ERROR_INVALID_CONFIG:
        'Щось пішло не так. Спробуйте ще раз.',
    PASSIVE_LIVENESS_ERROR_NO_SUCH_OBJECT_IN_BUILD_TITLE:
        'Ой... Щось пішло не так.',
    PASSIVE_LIVENESS_ERROR_NO_SUCH_OBJECT_IN_BUILD:
        'Щось пішло не так. Спробуйте ще раз.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_PREDICT_TITLE:
        'Ой... Щось пішло не так.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_PREDICT:
        'Щось пішло не так. Спробуйте ще раз.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_DETECT_TITLE:
        'Ой... Щось пішло не так.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_DETECT:
        'Щось пішло не так. Спробуйте ще раз.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREDICT_LANDMARKS_TITLE:
        'Ой... Щось пішло не так.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREDICT_LANDMARKS:
        'Щось пішло не так. Спробуйте ще раз.',
    PASSIVE_LIVENESS_ERROR_INVALID_FUSE_MODE_TITLE: 'Ой... Щось пішло не так.',
    PASSIVE_LIVENESS_ERROR_INVALID_FUSE_MODE:
        'Щось пішло не так. Спробуйте ще раз.',
    PASSIVE_LIVENESS_ERROR_NULLPTR_TITLE: 'Ой... Щось пішло не так.',
    PASSIVE_LIVENESS_ERROR_NULLPTR: 'Щось пішло не так. Спробуйте ще раз.',
    PASSIVE_LIVENESS_ERROR_LICENSE_ERROR_TITLE: 'Ой... Щось пішло не так.',
    PASSIVE_LIVENESS_ERROR_LICENSE_ERROR:
        'Щось пішло не так. Спробуйте ще раз.',
    PASSIVE_LIVENESS_ERROR_INVALID_META_TITLE: 'Ой... Щось пішло не так.',
    PASSIVE_LIVENESS_ERROR_INVALID_META: 'Щось пішло не так. Спробуйте ще раз.',
    INITIALIZING_TITLE: 'Ініціалізація',
    INITIALIZING_DESCRIPTION:
        'Перевірка апаратних можливостей, будь ласка, зачекайте...',
    JOURNEY_STATE_STARTED: 'Початок',
    JOURNEY_STATE_INPROGRESS: 'У процесі',
    JOURNEY_STATE_ENDED: 'Закінчено',
    INFO_JOURNEY_STATE: 'Держава',
    INFO_JOURNEY_ACTION: 'Дія',
    INFO_JOURNEY_ACTION_ATTEMPT: 'Спроба дії',
    INFO_JOURNEY_ID: 'Ідентифікатор подорожі',
    INFO_JOURNEY_RESULT: 'Результат',
    RESULTS_HIGH_LEVEL_EXPIRED_MESSAGE: 'Повідомлення результату',
    RESULTS_HIGH_LEVEL_EXPIRED_MESSAGE_VALUE:
        'Цей ідентифікатор, який ви нам дали, застарів – спробуйте щось інше',
    INFO_JOURNEY_REFERENCE: 'Посилання',
    FLOW_STATE_NONE: 'Жоден',
    'FLOW_STATE_IDENTITY:FRONT': 'Передня сторона',
    'FLOW_STATE_IDENTITY:BACK': 'Задня сторона',
    FLOW_STATE_ADDRESS: 'Адреса',
    FLOW_STATE_SELFIE: 'Селфі.',
    FLOW_STATE_LIVENESS: 'Живість',
    FLOW_STATE_COVID: 'Covid',
    PROVIDER_TITLE_CAMERA: 'Камера',
    PROVIDER_TITLE_CROPPER: 'Кропач',
    PROVIDER_TITLE_FILESYSTEM_ID:
        'Завантажте фотографію свого документа, що посвідчує особу',
    PROVIDER_TITLE_FILESYSTEM_FACEMATCH: 'Завантажте свою фотографію',
    PROVIDER_TITLE_FILESYSTEM_ADDRESS:
        'Завантажте фотографію свого підтвердження адреси',
    PROVIDER_TITLE_FILESYSTEM_COVID:
        'Завантажте фотографію свого Covid-документа',
    PROVIDER_TITLE_GATEWAY: 'Шлюз',
    PROVIDER_TITLE_LIVENESS: 'Живість',
    PROVIDER_TITLE_LOGIN: 'Увійти',
    PROVIDER_TITLE_RESULTS: 'Результати',
    PROVIDER_TITLE_SCANNER: 'Відскануйте свій документ, що посвідчує особу',
    PROVIDER_TITLE_VIEW_ID:
        'Перевірте попередній перегляд свого документа, що посвідчує особу',
    PROVIDER_TITLE_VIEW_FACEMATCH: 'Перевірте попередній перегляд свого селфі',
    PROVIDER_TITLE_VIEW_ADDRESS:
        'Перевірте попередній перегляд вашого підтвердження адреси',
    ROVIDER_TITLE_VIEW_COVID: 'Перевірте попередній перегляд вашого Covid',
    PROVIDER_SUBTITLE_FILESYSTEM_ID:
        'Будь ласка, завантажте фотографію свого документа, що посвідчує особу, чітку, у фокусі, незакриту та прямою стороною.',
    PROVIDER_SUBTITLE_FILESYSTEM_FACEMATCH:
        'Будь ласка, завантажте свою фотографію, яка буде чіткою, у фокусі, не закритою та прямо обличчям до вас',
    PROVIDER_SUBTITLE_FILESYSTEM_ADDRESS:
        'Будь ласка, завантажте фотографію свого документа, яка є чіткою, у фокусі, не закритою та прямою стороною.',
    PROVIDER_SUBTITLE_FILESYSTEM_COVID:
        'Будь ласка, завантажте фотографію свого документа, яка є чіткою, у фокусі, не закритою та прямою стороною.',
    PROVIDER_SUBTITLE_SCANNER_ID:
        'Покладіть сторінку з фотографією вашого документа, що посвідчує особу, на сканер лицьовою стороною вниз.',
    PROVIDER_SUBTITLE_VIEW_ID:
        'Будь ласка, перевірте, щоб попередній перегляд вашого документа був чітким, у фокусі, не закритим і прямо навпроти.',
    PROVIDER_SUBTITLE_VIEW_FACEMATCH:
        'Будь ласка, переконайтеся, що попередній перегляд вашого селфі чіткий, у фокусі, не прикритий і прямо обличчям.',
    PROVIDER_SUBTITLE_VIEW_ADDRESS:
        'Будь ласка, перевірте, щоб попередній перегляд вашого документа був чітким, у фокусі, не закритим і прямо навпроти.',
    PROVIDER_SUBTITLE_VIEW_COVID:
        'Будь ласка, перевірте, щоб попередній перегляд вашого документа був чітким, у фокусі, не закритим і прямо навпроти.',
    PROVIDER_TITLE_SMART_CAPTURE: 'Розумний захоплення',
    PROVIDER_TITLE_JOURNEY_SELECT: 'Виберіть подорож',
    PROVIDER_TITLE_TERMS_AND_CONDITIONS: 'Умови та положення',
    PROVIDER_TITLE_USER_INPUT: 'Будь ласка, заповніть наступну форму',
    FILESYSTEM_SUPPORTED_TYPES_FIRST: 'Прийняті формати:',
    FILESYSTEM_SUPPORTED_TYPES_LIST: 'JPG, PNG',
    FILESYSTEM_SUPPORTED_TYPES_START_SELFIE: 'Прийняті формати: JPG, PNG',
    FILESYSTEM_MAX_FILE_SIZE: 'Розмір файлу: ми приймаємо файли розміром менше',
    FILESYSTEM_MAX_FILE_SIZE_NUMBER: '7,5 МБ',
    FILESYSTEM_CHECK_FILE_TOO_BIG:
        'Ваш файл занадто великий. Будь ласка, завантажте файл, розмір якого не перевищує 7,5 МБ.',
    FILESYSTEM_CHECK_FILE_INCORRECT_FORMAT:
        'Ваш файл має неправильний формат. Будь ласка, завантажте один з прийнятих форматів.',
    FILESYSTEM_IDENTITY_DOCUMENT: 'Документ, що посвідчує особу',
    FILESYSTEM_FACEMATCH: 'Очний матч',
    FILESYSTEM_ADDRESS: 'Підтвердження адреси',
    FILESYSTEM_COVID: 'Covid',
    FILESYSTEM_DRAG_DROP: 'Перетягування',
    FILESYSTEM_OR: 'або',
    FILESYSTEM_CHOOSE: 'Виберіть файл',
    FILESYSTEM_UPLOADING: 'Завантаження...',
    TRIPLESCAN_GUIDANCE_TRYAGAIN: 'Спробуйте ще раз.',
    FAILURE_REASON_REFER:
        'Ваш документ, що посвідчує особу, не пройшов перевірку.',
    FAILURE_REASON_EXPIRED:
        'Термін дії вашого документа, що посвідчує особу, закінчився.',
    FAILURE_REASON_NOT_ACCEPTED:
        'Ваш документ, що посвідчує особу, не є прийнятним типом документа.',
    FAILURE_REASON_NOT_SUPPORTED:
        'Ваш документ, що посвідчує особу, не може бути класифікований або не підтримується.',
    PLEASE_TRY_AGAIN_REFER: 'Будь ласка, спробуйте ще раз.',
    PLEASE_TRY_AGAIN_EXPIRED:
        'Будь ласка, спробуйте ще раз з дійсним документом.',
    PLEASE_TRY_AGAIN_NOT_ACCEPTED:
        'Будь ласка, спробуйте ще раз з іншим документом.',
    PLEASE_TRY_AGAIN_NOT_SUPPORTED: 'Будь ласка, спробуйте ще раз.',
    BLUR_CHECK_REASON: 'Розмитість - документ нечіткий;',
    GLARE_CHECK_REASON:
        'Відблиски - документ не читається через яскраве джерело світла;',
    RESOLUTION_CHECK_REASON:
        'Низька роздільна здатність - документ не заповнює рамку належним чином;',
    EDGES_CHECK_REASON:
        'Відсутні краї - документ неправильно розміщений у рамці;',
    VALIDATION_FAILED: 'Валідація не пройшла',
    VALIDATION_FAILED_REASON_DOC_UNKNOWN: '- документ невідомий.',
    VALIDATION_FAILED_REASON_DOC_NOT_ACCEPTED: '- документ не прийнято.',
    VALIDATION_FAILED_REASON_DOC_EXPIRED: '- термін дії документа закінчився.',
    PREVIEW_INFO_TITLE_ID: 'Приклади хороших і поганих фотографій',
    PREVIEW_INFO_GOOD: 'Добре.',
    PREVIEW_INFO_BAD: 'Погано.',
    PREVIEW_INFO_GOOD_EXAMPLE_ID:
        'Фотографія чітка, у фокусі, з прямим обличчям.',
    PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ID:
        'На фото повинні бути видні всі чотири кути.',
    PREVIEW_INFO_BAD_EXAMPLE_COVER_ID: 'Документ не повинен бути закритий.',
    PREVIEW_INFO_BAD_EXAMPLE_BLUR_ID: 'Фото не повинно бути розмитим.',
    PREVIEW_INFO_TITLE_FACEMATCH: 'Поради для якісного селфі',
    PREVIEW_INFO_GOOD_EXAMPLE_FACEMATCH:
        'Селфі чітке, у фокусі та прямо на обличчі.',
    PREVIEW_INFO_BAD_EXAMPLE_ANGLE_FACEMATCH:
        'Селфі має показувати повне обличчя.',
    PREVIEW_INFO_BAD_EXAMPLE_COVER_FACEMATCH:
        'Обличчя не повинно бути закрите.',
    PREVIEW_INFO_BAD_EXAMPLE_BLUR_FACEMATCH: 'Селфі не повинно бути розмитим.',
    PREVIEW_INFO_TITLE_ADDRESS: 'Поради для отримання якісних фотографій',
    PREVIEW_INFO_GOOD_EXAMPLE_ADDRESS:
        'Фотографія чітка, у фокусі, з прямим обличчям.',
    PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ADDRESS:
        'На фото повинні бути видні всі чотири кути.',
    PREVIEW_INFO_BAD_EXAMPLE_COVER_ADDRESS:
        'Документ не повинен бути закритий.',
    PREVIEW_INFO_BAD_EXAMPLE_BLUR_ADDRESS: 'Фото не повинно бути розмитим.',
    PREVIEW_INFO_TITLE_COVID: 'Поради для отримання якісних фотографій',
    PREVIEW_INFO_GOOD_EXAMPLE_COVID:
        'Фотографія чітка, у фокусі, з прямим обличчям.',
    PREVIEW_INFO_BAD_EXAMPLE_ANGLE_COVID:
        'На фото повинні бути видні всі чотири кути.',
    PREVIEW_INFO_BAD_EXAMPLE_COVER_COVID: 'Документ не повинен бути закритий.',
    PREVIEW_INFO_BAD_EXAMPLE_BLUR_COVID: 'Фото не повинно бути розмитим.',
    ATTEMPTS_REMAINING: 'Кількість залишених спроб:',
    CAMERA_CAPTURE: 'Увімкніть камеру',
    CAMERA_CAPTURE_START_BUTTON: 'Запустити автозйомку',
    CAMERA_CAPTURE_CAPTION: 'Натисніть на кнопку Почати автозйомку, щоб почати',
    CAMERA_PREVIEW_START: 'Увімкніть камеру, щоб запустити автозйомку',
    CAMERA_CONDITION_BLUR: 'Виявлено розмиття.',
    CAMERA_CONDITION_CAPTURING: 'Захоплення',
    CAMERA_CONDITION_UPLOADING: 'Завантаження... Будь ласка, зачекайте.',
    CAMERA_CONDITION_ALIGNMENT: 'Документ не у фреймі',
    CAMERA_CONDITION_GLARE: 'Виявлено відблиски',
    VERIFYING_TITLE: 'Перевірка ...',
    PREPARING_PREVIEW_TITLE: 'Підготовка попереднього перегляду ...',
    CAMERA_CONDITION_LOW_RESOLUTION: 'Документувати занадто далеко',
    CAMERA_LOADING: 'Камера на старт...',
    CAMERA_SMARTCAPTURE_ON: 'АВТОЗЙОМКА - УВІМКНЕНО',
    CAMERA_SMARTCAPTURE_OFF: 'АВТОЗЙОМКА - ВИМКНЕНО',
    CAMERA_CAPTURE_FRONT:
        'Розмістіть бік із фотографією вашого документа посвідчення особи в рамці нижче.',
    CAMERA_MANUAL_CAPTURE_FRONT:
        'Помістіть ваш документ, що посвідчує особу, у рамку та натисніть на кнопку нижче',
    CAMERA_CAPTURE_BACK:
        'Розмістіть зворотний бік документа, що посвідчує особу, у рамці',
    CAMERA_CAPTURE_SELFIE_CAPTION:
        'Розмістіть обличчя в межах овалу, дивіться прямо в камеру і натисніть на кнопку нижче, щоб зробити селфі.',
    AMERA_CAPTURE_ADDRESS_CAPTION:
        'Помістіть ваше підтвердження адреси в рамку і натисніть на кнопку нижче, щоб зробити фото.',
    CAMERA_CAPTURE_COVID_CAPTION:
        'Помістіть ваш Covid-документ у рамку і натисніть на кнопку нижче, щоб зробити фото.',
    CAMERA_PREVENT_GLARE_HINT:
        'Перемістіть документ подалі від прямих джерел світла.',
    CAMERA_PREVENT_BLUR_HINT: 'Тримайте документ або пристрій рівно.',
    CAMERA_PREVENT_LOW_RES_HINT: 'Повністю помістіть документ у рамку.',
    CROPPER_RETRY: 'Спробуйте ще раз.',
    CROPPER_UPLOAD: 'Завантажити',
    CROPPER_UPLOADING: 'Завантаження...',
    FILESYSTEM_SELECT: 'Виберіть',
    FILESYSTEM_DROP_IMAGE: 'або Drop Image',
    GATEWAY_CAMERA: 'Камера увімкнена',
    GATEWAY_CANCEL: 'Скасувати подорож',
    LIVENESS_START: 'Почніть життя',
    PASSIVE_LIVENESS_START: 'Сфотографувати',
    LOGIN_USERNAME: "Ім'я користувача",
    LOGIN_PASSWORD: 'Пароль',
    LOGIN_SUBMIT: 'Подати',
    RESULTS_DOCUMENTS: 'Документи',
    RESULTS_DOCUMENTS_NONE: 'Не знайдено',
    RESULTS_DOCUMENT_TYPE: 'Тип документа',
    RESULTS_DOCUMENT_RESULT: 'Документ Результат',
    RESULTS_EXTRACTED_FIELDS_NONE: 'Деталі результату',
    RESULTS_DETAILS_NONE: 'Не знайдено',
    RESULTS_NEW_JOURNEY: 'Почати нову подорож.',
    RESULTS_NO_INFORMATION: 'Немає інформації про цю подорож',
    RESULTS_LOGOUT: 'Вийти',
    RESULTS_HIGH_LEVEL_Aborted: 'Перервано',
    RESULTS_HIGH_LEVEL_TCCDISAGREE: 'Перервано T&C',
    RESULTS_HIGH_LEVEL_Expired: 'Закінчився',
    RESULTS_HIGH_LEVEL_NotAccepted: 'Не прийнято',
    RESULTS_HIGH_LEVEL_NotSupported: 'Не підтримується',
    RESULTS_HIGH_LEVEL_Notsupported: 'Не підтримується',
    RESULTS_HIGH_LEVEL_Passed: 'Пройшов.',
    RESULTS_HIGH_LEVEL_Refer: 'Звертатися',
    RESULTS_HIGH_LEVEL_Undefined: 'Невизначений',
    RESULTS_HIGH_LEVEL_DETAIL_ACCUMULATIVELIVENESSRESULT:
        'Накопичений результат життєздатності',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTFRONTSIDETYPECHECK:
        'Перевірка типу передньої сторони документа',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTBACKSIDECHECK:
        'Перевірка зворотньої сторони документа',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTBLOCKINGPOLICY:
        'Політика блокування документів',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTEXPIRY: 'Термін дії документа',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTSUPPORT: 'Підтримка документів',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTVALIDATION: 'Перевірка документів',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTPROOFPOLICY:
        'Політика документального підтвердження',
    RESULTS_HIGH_LEVEL_DETAIL_FACEMATCHVALIDATION: 'Підтвердження Facematch',
    RESULTS_HIGH_LEVEL_DETAIL_UNDERAGERULE: 'Неповнолітній правило',
    ESULTS_HIGH_LEVEL_DETAIL_VALUE_SUCCESS_NEEDED: 'Необхідний успіх',
    RESULTS_HIGH_LEVEL_DETAIL_COVID_PASS_CROSSCHECK:
        'Перевірка сумісності Covid-паспорта',
    RESULTS_HIGH_LEVEL_DETAIL_DATA_CHECK: 'Перевірка даних',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_FAILED: 'Не вдалося',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_NOTNEEDED: 'Не потрібно',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_PASSED: 'Пройшов.',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_SKIPPED: 'Пропущено',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_UNDETERMINED: 'Не визначено',
    ADDITIONAL_CHECKS_DETAILS: 'Додаткові перевірки',
    ADDITIONAL_CHECKS_DETAILS_NONE: 'Не знайдено',
    ADDITIONAL_CHECKS_DETAIL_DATACHECKS: 'Перевірки даних',
    ADDITIONAL_CHECKS_DETAIL_LOOKBACKCHECK: 'Оглядові перевірки',
    ADDITIONAL_CHECKS_DETAIL_LOOKBACKCHECK_NA: 'Н/Д',
    GBG_SCORES: 'Оцінки GBG',
    GBG_TRUST_SCORE: 'Рейтинг довіри GBG',
    GBG_SCORE: 'Оцінка GBG',
    PREVIEW_TITLE: 'Фото вашого документа чітке?',
    VIEW_RETRY: 'ЗРОБИТИ ФОТО ЗНОВУ',
    VIEW_RETRY_DESKTOP: 'Змінити фотографію',
    VIEW_CROP: 'Врожай',
    VIEW_CROPPING: 'Обрізка...',
    VIEW_UPLOAD: 'Завантажити',
    VIEW_UPLOAD_PREVIEW: 'ТАК, ПРОДОВЖИТИ',
    VIEW_UPLOADING: 'Завантаження...',
    SMART_CAPTURE_INITIALIZING: 'Початок',
    SMART_CAPTURE_START:
        'Ініціалізація Smart Capture, Будь ласка, зачекайте...',
    SCANNER_DESC_AVAILABLE:
        'Сканер доступний. Покладіть свій документ на сканер.',
    SCANNER_DESC_PROCESSING: 'Зображення обробляється сервером.',
    SCANNER_DESC_SCANNING: 'Зображення сканується пристроєм.',
    SCANNER_DESC_DISCONNECTED: 'Сканер відключений від мережі.',
    SCANNER_DESC_NOT_CONNECTED: 'Сканер не підключений.',
    SCANNER_DESC_OFFLINE: 'Сканер відключений.',
    SCANNER_DESC_BUSY:
        'Сканер використовується іншим користувачем у вашій локальній мережі.',
    SCANNER_DESC_WAITING: "Чекаю на встановлення з'єднання.",
    SCANNER_DESC_LOADING: 'Будь ласка, зачекайте...',
    SCANNER_TITLE_SCANNING: 'СКАНУВАННЯ...',
    SCANNER_TITLE_DISCONNECTED: 'ВІДКЛЮЧЕНИЙ',
    SCANNER_TITLE_NOT_CONNECTED: 'НЕ ПІДКЛЮЧЕНИЙ',
    SCANNER_TITLE_OFFLINE: 'Сканер не в мережі',
    SCANNER_TITLE_BUSY: 'Сканер зайнятий',
    SCANNER_TITLE_WAITING: 'ЧЕКАННЯ',
    SCANNER_ACTION_REGISTER: 'Реєстрація',
    SCANNER_ACTION_RELEASE: 'Випуск',
    CANCEL_JOURNEY: 'Скасувати',
    MANUAL_PHOTO_UPLOAD_TOGGLE_FALSE: 'Завантажте фото замість цього',
    MANUAL_PHOTO_UPLOAD_TOGGLE_TRUE: 'Замість цього зробіть фото',
    JOURNEY_SELECT_CONTINUE: 'Продовжити',
    HELP_MODAL_AUTOCAPTURE_TITLE: 'Як сфотографувати ваше посвідчення особи',
    HELP_MODAL_AUTOCAPTURE_SUBTITLE:
        'Якщо увімкнено функцію автоматичного захоплення, екран захоплення автоматично зробить фотографію вашого документа, коли визначить, що вона має достатню якість.',
    HELP_MODAL_AUTOCAPTURE_TIPS: 'Поради щодо створення якісних фотографій',
    HELP_MODAL_AUTOCAPTURE_GLARE_TITLE: 'Запобігайте відблискам',
    HELP_MODAL_AUTOCAPTURE_GLARE_SUBTITLE:
        'Перемістіть документ подалі від прямих джерел світла.',
    HELP_MODAL_AUTOCAPTURE_FAR_TITLE: 'Документ занадто далеко',
    AUTOCAPTURE_FAR_SUBTITLE: 'Вмістіть документ повністю в рамку.',
    AUTOCAPTURE_BLUR_TITLE: 'Запобігання розмиттю',
    HELP_MODAL_AUTOCAPTURE_BLUR_SUBTITLE:
        'Тримайте документ або пристрій рівно.',
    HELP_MODAL_AUTOCAPTURE_MANUAL_CAPTURE:
        'Все ще не виходить? Сфотографуйте в режимі ручного захоплення',
    HELP_MODAL_AUTOCAPTURE_TURN_MANUAL_CAPTURE: 'Ручна зйомка',
    HELP_MODAL_SELFIE_TITLE: 'Як зробити селфі',
    HELP_MODAL_SELFIE_SUBTITLE:
        'Дивіться прямо в камеру і натисніть кнопку ручного захоплення.',
    HELP_MODAL_POA_TITLE: 'Як сфотографувати підтвердження адреси',
    HELP_MODAL_POA_SUBTITLE:
        'Помістіть документ у рамку і натисніть на кнопку захоплення, щоб зробити фото документа.',
    HELP_MODAL_POA_TIPS: 'Поради для отримання якісних фотографій',
    HELP_MODAL_POA_GLARE_TITLE: 'Запобігайте відблискам',
    HELP_MODAL_POA_GLARE_SUBTITLE:
        'Перемістіть документ подалі від прямих джерел світла.',
    HELP_MODAL_POA_FAR_TITLE: 'Документ занадто далеко',
    HELP_MODAL_POA_FAR_SUBTITLE: 'Вмістіть документ повністю в рамку.',
    HELP_MODAL_POA_BLUR_TITLE: 'Запобігання розмиттю',
    HELP_MODAL_POA_BLUR_SUBTITLE: 'Тримайте документ або пристрій рівно.',
    HELP_MODAL_POA_MANUAL_CAPTURE:
        'Все ще не вдається? Увімкніть ручне захоплення',
    HELP_MODAL_POA_TURN_MANUAL_CAPTURE: 'Захоплення вручну',
    HELP_MODAL_COVID_TITLE: 'Як сфотографувати ваш документ Covid',
    HELP_MODAL_COVID_SUBTITLE:
        'Помістіть документ у рамку та натисніть на кнопку захоплення, щоб зробити фото документа.',
    HELP_MODAL_COVID_TIPS: 'Поради для отримання якісних фотографій',
    HELP_MODAL_COVID_GLARE_TITLE: 'Запобігайте відблискам',
    HELP_MODAL_COVID_GLARE_SUBTITLE:
        'Перемістіть документ подалі від прямих джерел світла,',
    HELP_MODAL_COVID_FAR_TITLE: 'Документ занадто далеко',
    HELP_MODAL_COVID_FAR_SUBTITLE: 'Вмістіть документ повністю в рамку.',
    HELP_MODAL_COVID_BLUR_TITLE: 'Запобігання розмиттю',
    HELP_MODAL_COVID_BLUR_SUBTITLE: 'Тримайте документ або пристрій рівно.',
    HELP_MODAL_COVID_MANUAL_CAPTURE:
        'Все ще не вдається? Увімкніть ручне захоплення',
    HELP_MODAL_COVID_TURN_MANUAL_CAPTURE: 'Захоплення вручну',
    HELP_MODAL_NEED_HELP: 'Допомога та параметри',
    EXCEPTION: 'Виникла непередбачувана виняток',
    EXCEPTION_AUTHORIZATION: 'Неавторизований',
    EXCEPTION_AUTHORIZATION_ACCOUNT_NOT_AUTHORIZED:
        'Ваш обліковий запис не авторизований для доступу до цього ресурсу',
    EXCEPTION_AUTHORIZATION_AUTH_DETAILS_INVALID:
        'Комбінація імені користувача та пароля не є дійсною',
    EXCEPTION_AUTHORIZATION_AUTH_NOT_ENABLED:
        'Ви повинні увімкнути авторизацію, щоб використовувати цю функцію',
    EXCEPTION_AUTHORIZATION_PROCESS_NOT_AUTHORIZED:
        'Ви не авторизовані для цього процесу',
    EXCEPTION_BAD_REQUEST: 'Поганий запит з кодом статусу 400',
    EXCEPTION_BAD_REQUEST_INVALID_IMAGE: 'Недійсне зображення',
    EXCEPTION_BAD_REQUEST_WAITING_FOR_RESPONSE: 'Подорож чекає на відповідь',
    EXCEPTION_FLOW_STATE_JOURNEY_ENDED:
        'Неможливо відправити запит. Подорож завершено',
    EXCEPTION_FLOW_STATE_MISSING: 'Стан потоку не знайдено',
    EXCEPTION_INVALID_PARAMETER_CALLBACK_MUST_BE_FUNCTION:
        'Callback повинна бути дійсною функцією',
    EXCEPTION_INVALID_PARAMETER_NAME_MUST_BE_STRING:
        'Назва події повинна бути рядковим значенням',
    EXCEPTION_INVALID_PARAMETER_PRIORITY_MUST_BE_NUMBER:
        'Пріоритет повинен бути числом.',
    EXCEPTION_INVALID_PARAMETER_PRIORITY_MUST_BE_POSITIVE_NUMBER:
        'Пріоритет повинен бути позитивним числом.',
    EXCEPTION_INVALID_PARAMETER_SHOULD_BE_ELEMENT_OR_SELECTOR:
        'Контейнер повинен бути або елементом, або селектором.',
    EXCEPTION_INVALID_PARAMETER_VALUE_NOT_VALID: 'Значення недійсне',
    EXCEPTION_INVALID_PARAMETER_VALUE_DAMAGED: 'Значення було пошкоджено.',
    EXCEPTION_MISSING_PARAMETER_BACKEND_URL_MISSING:
        'Конфігурація повинна включати параметр backendUrl.',
    EXCEPTION_MISSING_PARAMETER_COORDINATES_MISSING:
        'Постачані параметри повинні містити координати.',
    EXCEPTION_MISSING_PARAMETER_IMAGES_MISSING:
        'Постачані параметри повинні містити зображення.',
    EXCEPTION_MISSING_PARAMETER_PASSWORD_MISSING:
        'Надані параметри повинні містити пароль.',
    EXCEPTION_MISSING_PARAMETER_USERNAME_MISSING:
        "Постачані параметри повинні містити ім'я користувача.",
    EXCEPTION_MISSING_REQUIRED_FIELD_MISSING:
        "Будь ласка, заповніть всі обов'язкові поля",
    EXCEPTION_POSTCODE_FORMAT_ERROR:
        'Формат поштового індексу не дійсний minLength:5 / maxLength:8',
    EXCEPTION_HOUSENUMBER_FORMAT_ERROR:
        'Назва будинку/номер будинку не допустимий формат minLength:1 / maxLength:20',
    EXCEPTION_STREETNAME_FORMAT_ERROR:
        'Назва вулиці не допустима minLength:1 / maxLength:30',
    EXCEPTION_TOWN_FORMAT_ERROR:
        'Формат міста не допустимий minLength:1 / maxLength:20',
    EXCEPTION_JOURNEY_DEFINITIONS_MISSING:
        'Для цього каналу немає визначень маршрутів',
    EXCEPTION_NETWORK:
        "Виникла мережева помилка, перевірте з'єднання та спробуйте ще раз",
    EXCEPTION_PLATFORM_BROWSER_ONLY:
        'Цю функцію можна використовувати лише у браузері',
    EXCEPTION_PLATFORM_UNSUPPORTED: 'Ваше середовище не підтримує цю функцію',
    EXCEPTION_PLATFORM_CAMERA_PERMISSION_DENIED:
        'Дозволи на камеру не надано, перевірте налаштування вашого браузера',
    EXCEPTION_PLATFORM_CAMERA_PERMISSION_UNAVAILABLE:
        'Дозволи на камеру недоступні',
    EXCEPTION_PLATFORM_CAMERA_NOT_READABLE:
        'Не вдалося отримати доступ до камери. Будь ласка, закрийте всі інші програми та спробуйте ще раз',
    EXCEPTION_PLATFORM_CAMERA_NONE_SUITABLE:
        'На вашому пристрої не знайдено відповідних камер',
    EXCEPTION_SERVER: 'Запит не вдалося виконати з кодом статусу 500',
    EXCEPTION_SERVER_UNREACHABLE: 'Запит не виконано, сервер недоступний',
    EXCEPTION_SERVER_DATA_NOT_PERSISTED:
        'Виникла помилка під час процесу. Ваші дані не можуть бути збережені',
    EXCEPTION_SERVER_RESULT_NOT_PASSING: 'Поточний результат не передається',
    EXCEPTION_TEMPLATE_CANVAS_CONTEXT_UNAVAILABLE:
        'Контекст полотна недоступний',
    EXCEPTION_TEMPLATE_CONTAINER_MISSING: 'Контейнер відсутній',
    EXCEPTION_TEMPLATE_ELEMENTS_MISSING: 'Відсутні необхідні елементи',
    EXCEPTION_TEMPLATE_MISSING: 'Шаблон не знайдено',
    EXCEPTION_TEMPLATE_SOURCE_ELEMENT_MISSING:
        'Не вдалося знайти елемент-джерело',
    EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_CANNOT_RETRIEVE:
        'Не вдається отримати постачальників даних',
    EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_NONE_SPECIFIED:
        'Не вказано жодного постачальника даних',
    EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_NOT_AVAILABLE:
        'Постачальник даних недоступний',
    'SUPPORTED_DOCUMENT_Account Statement': 'Виписка з рахунку',
    'SUPPORTED_DOCUMENT_Agreement (Tenancy)': 'Угода (Оренда)',
    'SUPPORTED_DOCUMENT_Bank Document': 'Банківський документ',
    'SUPPORTED_DOCUMENT_Bank Letter': 'Лист від банку',
    'SUPPORTED_DOCUMENT_Bank Statement': 'Виписка з банку',
    'SUPPORTED_DOCUMENT_Benefit Letter': 'Лист з пільгами',
    'SUPPORTED_DOCUMENT_Certificate (Birth, Marriage, Civil partnership)':
        'Свідоцтво (народження, шлюб, цивільне партнерство)',
    'SUPPORTED_DOCUMENT_Council Document': 'Документ Ради',
    'SUPPORTED_DOCUMENT_Council Letter': 'Лист Ради',
    'SUPPORTED_DOCUMENT_Council Tax': 'Податок на житлово-комунальні послуги',
    'SUPPORTED_DOCUMENT_Driving License': 'Водійське посвідчення',
    'SUPPORTED_DOCUMENT_Driving Licence': 'Водійське посвідчення',
    'SUPPORTED_DOCUMENT_DWP Document': 'Документ DWP',
    'SUPPORTED_DOCUMENT_HMRC Document': 'Документ HMRC',
    'SUPPORTED_DOCUMENT_Information Sheet': 'Інформаційний листок',
    'SUPPORTED_DOCUMENT_Insurance Document': 'Документ страхування',
    'SUPPORTED_DOCUMENT_Insurance Letter': 'Лист про страхування',
    SUPPORTED_DOCUMENT_Invoice: 'Рахунок',
    'SUPPORTED_DOCUMENT_NIC Letter': 'Лист NIC',
    'SUPPORTED_DOCUMENT_NINO Letter': 'Лист НІНО',
    'SUPPORTED_DOCUMENT_Official Document': 'Офіційний документ',
    'SUPPORTED_DOCUMENT_Official Letter': 'Офіційний лист',
    'SUPPORTED_DOCUMENT_Repayment Letter (related to Tax or Social support)':
        'Лист про погашення (щодо податків або соціальної підтримки)',
    'SUPPORTED_DOCUMENT_Tax Letter': 'Податковий лист',
    'SUPPORTED_DOCUMENT_Tax Statement': 'Податкова декларація',
    'SUPPORTED_DOCUMENT_Tel Bill': 'Рахунок за телефон',
    'SUPPORTED_DOCUMENT_Tel Letter': 'Лист Тел',
    'SUPPORTED_DOCUMENT_Telecommunication Document':
        'Телекомунікаційний документ',
    'SUPPORTED_DOCUMENT_TV Licence': 'Телевізійна ліцензія',
    'SUPPORTED_DOCUMENT_University Letter': 'Університетський лист',
    'SUPPORTED_DOCUMENT_Utility Bill': 'Рахунок за комунальні послуги',
    'SUPPORTED_DOCUMENT_Utility Document': 'Документ про корисність',
    'SUPPORTED_DOCUMENT_Utility Letter': 'Допоміжний лист',
    'SUPPORTED_DOCUMENT_Water Bil': 'Водний біль',
    'SUPPORTED_DOCUMENT_Water Document': 'Документ про воду',
    'SUPPORTED_DOCUMENT_Agents License': 'Ліцензія агента',
    'SUPPORTED_DOCUMENT_Electoral Card': 'Виборча картка',
    'SUPPORTED_DOCUMENT_Foreigner Identification Card':
        'Картка ідентифікації іноземця',
    'SUPPORTED_DOCUMENT_Health Card': "Картка здоров'я",
    'SUPPORTED_DOCUMENT_Job License': 'Ліцензія на роботу',
    'SUPPORTED_DOCUMENT_Membership Identification Card':
        'Картка ідентифікації членства',
    'SUPPORTED_DOCUMENT_Military Identification Card': 'Військовий посвідчення',
    'SUPPORTED_DOCUMENT_National Identification Card':
        'Національний ідентифікаційний документ',
    SUPPORTED_DOCUMENT_Passport: 'Паспорт',
    'SUPPORTED_DOCUMENT_Travel Permit': 'Дозвіл на подорожі',
    SUPPORTED_DOCUMENT_Visa: 'Віза',
    'SUPPORTED_DOCUMENT_Weapons Licence': 'Ліцензія на зброю',
    'SUPPORTED_DOCUMENT_Selfie Photo': 'Селфі фото',
    SUPPORTED_DOCUMENT_Unknown: 'Невідомий',
    SUPPORTED_DOCUMENT_COVIDPAS: 'Пропуск Covid',
    EXTRACTED_FIELDS_AddressFull: 'Адреса Повна',
    EXTRACTED_FIELDS_AddressCity: 'Адреса Місто',
    EXTRACTED_FIELDS_AddressPostCode: 'Адресний поштовий індекс',
    EXTRACTED_FIELDS_LastNameFirstPart: 'Прізвище Перша Частина',
    EXTRACTED_FIELDS_Sex: 'Cтать',
    EXTRACTED_FIELDS_BirthPlace: 'Місце народження',
    EXTRACTED_FIELDS_IssueNumber: 'Номер випуску',
    EXTRACTED_FIELDS_DocumentNumberCheckDigit:
        'Контрольна цифра номеру документа',
    EXTRACTED_FIELDS_BirthDate: 'Дата народження',
    EXTRACTED_FIELDS_DocumentNumber: 'Номер документу',
    EXTRACTED_FIELDS_FirstName: "Ім'я",
    EXTRACTED_FIELDS_ArbitraryDigit: 'Довільна цифра',
    EXTRACTED_FIELDS_FirstNameInitial: 'Перша літера імені',
    EXTRACTED_FIELDS_ExpiryDate: 'Термін придатності',
    EXTRACTED_FIELDS_IssueDate: 'Дата видачі',
    EXTRACTED_FIELDS_LastName: 'Прізвище',
    EXTRACTED_FIELDS_LicenseCategory: 'Категорія ліцензії',
    EXTRACTED_FIELDS_DocumentCategory: 'Категорія документу',
    EXTRACTED_FIELDS_DocumentType: 'Тип документу',
    EXTRACTED_FIELDS_NationalityCode: 'Код національності',
    EXTRACTED_FIELDS_MiddleName: 'По батькові',
    EXTRACTED_FIELDS_FirstIssuanceDate: 'Дата першого випуску',
    EXTRACTED_FIELDS_SecondLastName: 'Друге прізвище',
    EXTRACTED_FIELDS_FullName: "Повне ім'я",
    EXTRACTED_FIELDS_PersonalNumber: 'Персональний номер',
    EXTRACTED_FIELDS_NationalityName: 'Національність',
    EXTRACTED_FIELDS_BarcodeItems: 'Штрих-код',
    EXTRACTED_FIELDS_BirthPlaceCity: 'Місто народження',
    EXTRACTED_FIELDS_BirthPlaceState: 'Стан народження',
    EXTRACTED_FIELDS_BirthPlaceCountry: 'Країна народження',
    EXTRACTED_FIELDS_MRZFull: 'Повний MRZ',
    EXTRACTED_FIELDS_MRZLine1: 'Рядок MRZ 1',
    EXTRACTED_FIELDS_MRZLine2: 'Рядок MRZ 2',
    EXTRACTED_FIELDS_MRZLine3: 'Рядок MRZ 3',
    EXTRACTED_FIELDS_ObservationPage: 'Сторінка спостережень',
    EXTRACTED_FIELDS_IssuingAuthority: 'Орган видання',
    EXTRACTED_FIELDS_IssuingLocation: 'Місце видачі',
    EXTRACTED_FIELDS_MaritalStatus: 'Сімейний стан',
    EXTRACTED_FIELDS_Occupation: 'Окупація',
    EXTRACTED_FIELDS_AlienNumber: 'Чужий номер',
    EXTRACTED_FIELDS_Employer: 'Роботодавець',
    EXTRACTED_FIELDS_AddressLine1: 'Адреса рядок 1',
    EXTRACTED_FIELDS_AddressLine2: 'Адреса рядок 2',
    EXTRACTED_FIELDS_AddressLine3: 'Адресний рядок 3',
    EXTRACTED_FIELDS_AddressLine4: 'Адреса рядок 4',
    EXTRACTED_FIELDS_AddressState: 'Держава',
    EXTRACTED_FIELDS_AddressDistrict: 'Район',
    EXTRACTED_FIELDS_AddressBuildingNumber: 'Номер будівлі',
    EXTRACTED_FIELDS_AddressBuildingName: 'Назва будівлі',
    EXTRACTED_FIELDS_AddressStreet: 'Вулиця',
    EXTRACTED_FIELDS_AddressCountry: 'Країна',
    EXTRACTED_FIELDS_RefAddressFull: 'Адрес посилання',
    EXTRACTED_FIELDS_RefAddressLine1: 'Адреса посилання Рядок 1',
    EXTRACTED_FIELDS_RefAddressLine2: 'Посилання Адреса Рядок 2',
    EXTRACTED_FIELDS_RefAddressLine3: 'Посилання Адреса Рядок 3',
    EXTRACTED_FIELDS_RefAddressLine4: 'Адреса посилання Рядок 4',
    EXTRACTED_FIELDS_RefAddressCity: 'Адреса посилання Місто',
    EXTRACTED_FIELDS_RefAddressState: 'Адреса посилання Стан',
    EXTRACTED_FIELDS_RefAddressDistrict: 'Адреса посилання Район',
    EXTRACTED_FIELDS_RefAddressBuildingNumber: 'Адреса посилання Номер будівлі',
    EXTRACTED_FIELDS_RefAddressBuildingName: 'Адреса посилання Назва будівлі',
    EXTRACTED_FIELDS_RefAddressSubBuildingName:
        'Адреса посилання Підназва будівлі',
    EXTRACTED_FIELDS_RefAddressStreet: 'Адреса посилання на вулицю',
    EXTRACTED_FIELDS_RefAddressCountry: 'Посилання Адреса Країна',
    EXTRACTED_FIELDS_RefAddressPostCode: 'Адреса посилання Поштовий індекс',
    EXTRACTED_FIELDS_HealthNumber: "Номер здоров'я",
    EXTRACTED_FIELDS_Endorsements: 'Рекомендації',
    EXTRACTED_FIELDS_Constraints: 'Обмеження',
    EXTRACTED_FIELDS_LicenseMarine: 'Ліцензія Морська',
    EXTRACTED_FIELDS_Height: 'Висота',
    EXTRACTED_FIELDS_Weight: 'Вага',
    EXTRACTED_FIELDS_HairColor: 'Колір волосся',
    EXTRACTED_FIELDS_EyeColor: 'Колір очей',
    EXTRACTED_FIELDS_LensData: 'Зір',
    EXTRACTED_FIELDS_SocialSecurityNumber: 'Номер соціального забезпечення',
    EXTRACTED_FIELDS_NationalInsuranceNumber: 'Номер національного страхування',
    EXTRACTED_FIELDS_Race: 'Гонка',
    EXTRACTED_FIELDS_MotherName: "Ім'я матері",
    EXTRACTED_FIELDS_FatherName: "Ім'я батька",
    EXTRACTED_FIELDS_Parents: 'Батьки',
    EXTRACTED_FIELDS_Remarks: 'Примітки',
    EXTRACTED_FIELDS_DistinguishingMarks: 'Відмітні ознаки',
    EXTRACTED_FIELDS_PeriodOfStay: 'Період перебування',
    EXTRACTED_FIELDS_TaxNumber: 'Податковий номер',
    EXTRACTED_FIELDS_Donor: 'Донор',
    EXTRACTED_FIELDS_RFIDG1: 'RFID Сирові дані Група 1',
    EXTRACTED_FIELDS_RFIDG2: 'RFID Сирові дані Група 2',
    EXTRACTED_FIELDS_RFIDG3: 'RFID Сирові дані Група 3',
    EXTRACTED_FIELDS_RFIDG15: 'RFID Сирові дані Група 4',
    EXTRACTED_FIELDS_RFIDSOD: 'RFID Сирові дані Група 5',
    EXTRACTED_FIELDS_PortraitPhoto: 'Витягнуте фото портрету',
    EXTRACTED_FIELDS_Title: 'Назва',
    EXTRACTED_FIELDS_IssueDate2: 'Дата другого випуску',
    EXTRACTED_FIELDS_ExpiryDate2: 'Другий термін придатності',
    EXTRACTED_FIELDS_LicenseCategory2: 'Друга категорія ліцензії',
    EXTRACTED_FIELDS_IssueDate3: 'Третя дата випуску',
    EXTRACTED_FIELDS_ExpiryDate3: 'Третя дата закінчення.',
    EXTRACTED_FIELDS_LicenseCategory3: 'Третя категорія ліцензії',
    EXTRACTED_FIELDS_IssueDate4: 'Четверте видання Дата',
    EXTRACTED_FIELDS_ExpiryDate4: 'Четверта дата закінчення.',
    EXTRACTED_FIELDS_LicenseCategory4: 'Четверта категорія ліцензії',
    EXTRACTED_FIELDS_MRZCode1: 'Код MRZ 1',
    EXTRACTED_FIELDS_MRZCode2: 'Код MRZ 2',
    EXTRACTED_FIELDS_MRZStandardType: 'Стандартний тип MRZ',
    EXTRACTED_FIELDS_AddressStreetSuffix: 'Суфікс вулиці',
    EXTRACTED_FIELDS_AddressStreetType: 'Тип вулиці',
    EXTRACTED_FIELDS_AddressUnitNumber: 'Адреса Номер Одиниці',
    EXTRACTED_FIELDS_LicenseNumber: 'Номер ліцензії',
    EXTRACTED_FIELDS_AddressStateCode: 'Державний кодекс',
    EXTRACTED_FIELDS_AddressStreetTypeAbbreviation: 'Вулиця Абревіатура',
    EXTRACTED_FIELDS_AddressUnitType: 'Тип адресного блоку',
    EXTRACTED_FIELDS_AddressDeliveryPointIdentifier:
        'Ідентифікатор точки доставки',
    EXTRACTED_FIELDS_AgeCategory: 'Вікова категорія',
    EXTRACTED_FIELDS_ChildernCount: 'Кількість дітей',
    EXTRACTED_FIELDS_EntryMode: 'Режим введення',
    EXTRACTED_FIELDS_VAFNumber: 'Номер VAF',
    EXTRACTED_FIELDS_AddressLine5: 'Адреса рядок 5',
    EXTRACTED_FIELDS_RFIDPortraitPhoto: 'RFID портретне фото',
    EXTRACTED_FIELDS_RefAddressLine5: 'Адреса посилання Рядок 5',
    EXTRACTED_FIELDS_RefAddressStateCode: 'Адреса посилання Стан',
    EXTRACTED_FIELDS_RefAddressStreetType: 'Тип вулиці посилання адреси',
    EXTRACTED_FIELDS_RefAddressStreetTypeAbbreviation:
        'Адреса посилання Тип вулиці Абревіатура',
    EXTRACTED_FIELDS_RefAddressStreetSuffix: 'Адреса посилання Суфікс вулиці',
    EXTRACTED_FIELDS_RefAddressUnitNumber: 'Адреса посилання Номер одиниці',
    EXTRACTED_FIELDS_RefAddressUnitType: 'Адреса посилання Тип одиниці',
    EXTRACTED_FIELDS_RefAddressPostcodeType:
        'Посилання Адреса Поштовий індекс Тип',
    EXTRACTED_FIELDS_RefAddressDeliveryPointIdentifier:
        'Ідентифікатор поштової адреси доставки',
    EXTRACTED_FIELDS_RefAddressPOBoxNumber: 'Поштова адреса, номер скриньки.',
    EXTRACTED_FIELDS_RefAddressDependentLocality:
        'Адреса посилання Залежне місцевість',
    EXTRACTED_FIELDS_RefAddressDoubleDependentLocality:
        'Посилання Адреса Подвійне Залежне Населений Пункт',
    EXTRACTED_FIELDS_RefAddressThoroughfare: 'Адреса Вулиця',
    EXTRACTED_FIELDS_RefAddressThoroughfareDesc: 'Адреса посилання Опис вулиці',
    EXTRACTED_FIELDS_RefAddressDependentThoroughfare: 'Адреса залежної вулиці',
    EXTRACTED_FIELDS_RefAddressDependentThoroughfareDesc:
        'Адреса з посиланням на опис вулиці.',
    EXTRACTED_FIELDS_RefAddressSubBuildingNumber:
        'Адреса посилання Підбудова Номер',
    EXTRACTED_FIELDS_AddressSubBuildingNumber: 'Номер підбудови',
    EXTRACTED_FIELDS_AddressSubBuildingName: 'Назва підбудови',
    EXTRACTED_FIELDS_AddressPostCodeType: 'Тип поштового індексу',
    EXTRACTED_FIELDS_IssuingAuthorityType: 'Тип органу, що видав',
    EXTRACTED_FIELDS_Signature: 'Підпис',
    EXTRACTED_FIELDS_Hologram: 'Голограма',
    EXTRACTED_FIELDS_CardNumber: 'Номер картки',
    EXTRACTED_FIELDS_MiddleNameInitial: 'По батькові По-батькові',
    EXTRACTED_FIELDS_PermitNumber: 'Номер дозволу',
    EXTRACTED_FIELDS_ReferenceNumber: 'Номер посилання',
    EXTRACTED_FIELDS_CustomerNumber: 'Номер клієнта',
    EXTRACTED_FIELDS_BOSNumber: 'Номер BOS',
    EXTRACTED_FIELDS_StudentID: 'Номер студентського квитка',
    EXTRACTED_FIELDS_MembershipNumber: 'Номер членства',
    EXTRACTED_FIELDS_LicenseType: 'Тип ліцензії',
    EXTRACTED_FIELDS_LicenseType2: 'Тип ліцензії 2',
    EXTRACTED_FIELDS_LicenseType3: 'Тип ліцензії 3',
    EXTRACTED_FIELDS_LicenseType4: 'Тип ліцензії 4',
    EXTRACTED_FIELDS_DocumentTypeCode: 'Код типу документу',
    EXTRACTED_FIELDS_MRZDocumentNumberCheckDigit: 'Контрольна цифра MRZ',
    EXTRACTED_FIELDS_MRZBirthDateCheckDigit:
        'Контрольна цифра дати народження MRZ',
    EXTRACTED_FIELDS_MRZExpiryDateCheckDigit:
        'Контрольна цифра дати закінчення MRZ',
    EXTRACTED_FIELDS_MRZPersonalNumberCheckDigit:
        'Контрольна цифра особистого номера MRZ',
    EXTRACTED_FIELDS_MRZCompositeCheckDigit: 'Контрольна цифра складеного MRZ',
    EXTRACTED_FIELDS_SecondaryPortraitPhoto: 'Друге фото портрету',
    EXTRACTED_FIELDS_Fingerprint: 'Відбиток пальця',
    EXTRACTED_FIELDS_VersionNumber: 'Номер версії',
    EXTRACTED_FIELDS_Conditions: 'Умови',
    EXTRACTED_FIELDS_NickName: 'Псевдонім',
    EXTRACTED_FIELDS_AddressApartmentNumber: 'Номер квартири',
    EXTRACTED_FIELDS_AddressFloorNumber: 'Номер поверху',
    EXTRACTED_FIELDS_FirstNameLocal: "Ім'я місцеве",
    EXTRACTED_FIELDS_LastNameLocal: 'Прізвище Місцеве',
    EXTRACTED_FIELDS_FullNameLocal: "Повне ім'я місцеве",
    EXTRACTED_FIELDS_BirthPlaceLocal: 'Місце народження місцеве',
    EXTRACTED_FIELDS_IssuingAuthorityLocal:
        'Орган, що видав документ, місцевий',
    EXTRACTED_FIELDS_MotherNameLocal: "Ім'я матері місцеве",
    EXTRACTED_FIELDS_FatherNameLocal: "Батьківське ім'я Місцеве",
    EXTRACTED_FIELDS_AddressFullLocal: 'Адреса Повний Місцевий',
    EXTRACTED_FIELDS_MiddleNameLocal: 'По батькові Місцевий',
    EXTRACTED_FIELDS_AddressLine1Local: 'Адреса Рядок1 Місцевий',
    EXTRACTED_FIELDS_AddressLine2Local: 'Адреса Рядок2 Місцевий',
    EXTRACTED_FIELDS_AddressLine3Local: 'Адреса Рядок3 Місцевий',
    EXTRACTED_FIELDS_IndRefNumber1: 'Індивідуальний номер посилання 1',
    EXTRACTED_FIELDS_IndRefNumber2: 'Індивідуальний номер посилання 2',
    EXTRACTED_FIELDS_IndRefNumber3: 'Індивідуальний номер посилання 3',
    EXTRACTED_FIELDS_IndRefNumber4: 'Індивідуальний номер посилання 4',
    EXTRACTED_FIELDS_IndRefNumber5: 'Індивідуальний номер посилання 5',
    EXTRACTED_FIELDS_Name1: "Ім'я 1",
    EXTRACTED_FIELDS_Name2: "Ім'я 2",
    EXTRACTED_FIELDS_Name3: "Ім'я 3",
    EXTRACTED_FIELDS_Name4: "Ім'я 4",
    EXTRACTED_FIELDS_Name5: "Ім'я 5",
    EXTRACTED_FIELDS_RECIPIENT_NAME_1: "Ім'я одержувача 1",
    EXTRACTED_FIELDS_RECIPIENT_NAME_2: "Ім'я одержувача 2",
    EXTRACTED_FIELDS_RECIPIENT_NAME_3: "Ім'я одержувача 3",
    EXTRACTED_FIELDS_RECIPIENT_NAME_4: "Ім'я одержувача 4",
    EXTRACTED_FIELDS_RECIPIENT_ADDRESS_FULL: 'Повна адреса одержувача',
    EXTRACTED_FIELDS_IBAN: 'Номер рахунку IBAN',
    EXTRACTED_FIELDS_ACCOUNT_NUM: 'Номер рахунку',
    EXTRACTED_FIELDS_ISSUER: 'Емітент',
    EXTRACTED_FIELDS_RECIPIENT_ADDRESS_CITY: 'Адреса одержувача Місто',
    EXTRACTED_FIELDS_RECIPIENT_ADDRESS_POST_CODE:
        'Адреса отримувача Поштовий індекс',
    EXTRACTED_FIELDS_DAY: 'День',
    EXTRACTED_FIELDS_MONTH: 'Місяць',
    EXTRACTED_FIELDS_YEAR: 'Рік',
    EXTRACTED_FIELDS_OPTIONAL_VALUE_1: "Необов'язкове значення 1",
    EXTRACTED_FIELDS_OPTIONAL_VALUE_2: "Необов'язкове значення 2",
    EXTRACTED_FIELDS_OPTIONAL_VALUE_3: "Необов'язкове значення 3",
    EXTRACTED_FIELDS_OPTIONAL_VALUE_4: "Необов'язкове значення 4",
    EXTRACTED_FIELDS_ISSUING_STATE_NAME: 'Назва держави, що видала документ',
    EXTRACTED_FIELDS_FRONT_DOCUMENT_TYPE_ID:
        'Ідентифікатор типу документа на лицьовому боці',
    EXTRACTED_FIELDS_BACK_DOCUMENT_TYPE_ID:
        'Ідентифікатор типу документа на зворотному боці',
    HASNOCAMERA_TITLE:
        'На жаль, ми не змогли розпізнати камеру на вашому пристрої!',
    HASNOCAMERA_DESCRIPTION:
        'Схоже, що ваш пристрій не має камери, будь ласка, спробуйте на іншому пристрої, який має робочу камеру, щоб ви могли виконати всі необхідні кроки.',
    EXTRACTED_FIELDS_COVIDPASSCROSSCHECKRESULT: 'Ідентифікатор типу Covid',
    USER_INPUT_FIRST_NAME: "Ім'я",
    USER_INPUT_MIDDLE_NAME: "Друге ім'я",
    USER_INPUT_LAST_NAME: 'Прізвище',
    USER_INPUT_DOB: 'Дата народження',
    USER_INPUT_HOUSE_NAME_NUMBER:
        'Назва будинку/номер будинку* *Найменування/номер вулиці',
    USER_INPUT_STREET_NAME: 'Назва вулиці',
    USER_INPUT_TOWN: 'Населений пункт',
    USER_INPUT_POSTAL_CODE: 'Поштовий індекс',
    USER_INPUT_HOUSE_NAME_NUMBER_EXAMPLE: 'наприклад, будинок/35',
    USER_INPUT_STREET_NAME_EXAMPLE: 'наприклад, вулиця Тестова',
    USER_INPUT_TOWN_EXAMPLE: 'наприклад, Десь',
    USER_INPUT_POSTAL_CODE_EXAMPLE: 'наприклад, CH496 (без пробілів)',
    SYSTEM_NOT_ABLE: 'Система не змогла сканувати документ',
    TRY_AGAIN: 'Спробуйте ще раз',
    HINTS_DISABLED_HEADER: 'Поради вимкнені в ручному режимі',
    HINTS_DISABLED_DESCRIPTION:
        'Якщо ви хочете увімкнути поради для фотографування, перейдіть у режим АВТОМАТИЧНОГО ФОТОГРАФУВАННЯ',
    YOU_HAVE: 'Ви маєте',
    PICTURE_VERIFYING: 'Перевірка...',
    HOW_TO_TAKE_PHOTO_CORRECTLY: 'Як правильно зробити фото',
};
